import _regeneratorRuntime from "@babel/runtime/regenerator";
import ExpoFontLoader from "./ExpoFontLoader";
export function fontFamilyNeedsScoping(name) {
  return false;
}

function isAsset(asset) {
  return typeof asset === 'object' && 'uri' in asset && 'name' in asset;
}

export function getAssetForSource(source) {
  if (isAsset(source)) {
    return {
      uri: source.uri || source.localUri
    };
  }

  if (typeof source !== 'string') {
    throw new Error("Unexpected type " + typeof source + " expected a URI string or Asset from expo-asset.");
  }

  return {
    uri: source
  };
}
export function loadSingleFontAsync(name, input) {
  var asset;
  return _regeneratorRuntime.async(function loadSingleFontAsync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          asset = input;

          if (!asset.downloadAsync) {
            _context.next = 3;
            break;
          }

          throw new Error('expo-font: loadSingleFontAsync expected an asset of type FontResource on web');

        case 3:
          _context.next = 5;
          return _regeneratorRuntime.awrap(ExpoFontLoader.loadAsync(name, input));

        case 5:
        case "end":
          return _context.stop();
      }
    }
  });
}
export function getNativeFontName(name) {
  return name;
}